<div class="bp-modal mod-lg">
	<bp-modal-header
		title="Anti-phishing code">
	</bp-modal-header>
	<ng-container *ngTemplateOutlet="mainTemplate; context: { isSkippable: isSkippable$ | async }"></ng-container>
	<ng-template #mainTemplate let-isSkippable="isSkippable">
		<div class="bp-modal-body">
			<div class="extra-padding">
				<div class="bp-modal-body-section">
					<div class="text-center mt-20 mb-20">
						<img src="./assets/images/anti-phishing-banner.png" class="anti-phishing__banner" />
					</div>
					<span class="anti-phishing__one-minute">
						{{ "duration_one_minute" | translate }}
					</span>

					<!-- User can skip for 7 days -->
					<div class="mt-40">
						@if(isSkippable) {
						<h2>{{ "anti_phishing_code_bottomsheet_title" | translate }}</h2>
						<p class="anti-phishing__paragraph">{{ "anti_phishing_code_bottomsheet_description1" | translate }}</p>
						<p class="anti-phishing__paragraph">{{ "anti_phishing_code_bottomsheet_description2" | translate }}</p>
						} @else {
						<!-- User cannot skip and is forced to click setup -->
						<h2>{{ "anti_phishing_code_bottomsheet_title_nodismiss" | translate }}</h2>
						<p class="anti-phishing__paragraph">{{ "anti_phishing_code_bottomsheet_description1_nodismiss" | translate }}</p>
						}
					</div>
					<div class="extra-padding" class="mt-40">
						<button class="btn btn-primary anti-phishing__setup-button" (click)="onClickSetup()">
							<strong>{{ (isSkippable ? "set_up_code_now" : "set_up_code") | translate }}</strong>
						</button>
						@if(isSkippable) {
						<div class="text-center  mt-20">
							<a href="javascript:void(null);" class="anti-phishing__skip-link" (click)="onClickSkip()">
								<strong>{{ "skip" | translate }}</strong>
							</a>
						</div>
						}
					</div>
				</div>
			</div>
		</div>
	</ng-template>
</div>
